<template>
    <div class="x-card-tabs clearfix">
        <div class="x-card-tabs__nav float-left">
            <div v-for="(item, index) in items"
                 class="x-card-tabs__item"
                 :key="index"
                 :data-value="item.value"
                 :class="{ 'x-card-tabs__item--active': item.value === current }"
                 @click="change(item.value)">{{ item.label }}</div>
        </div>
        <div class="x-card-tabs__append"
             v-if="$slots.default && $slots.default.length">
            <slot></slot>
        </div>
    </div>
</template>

<script>
export default {
    name: 'XCardTabs',

    props: {
        value: {},
        items: {
            type: Array,
            default() {
                return []
            }
        }
    },
    computed: {
        current() {
            if (this.value) {
                return this.value
            }
            return this.items[0] && this.items[0].value
        }
    },
    methods: {
        change(value) {
            this.$emit('input', value)
            this.$emit('change', value)
        }
    }
}
</script>

<style lang="less" scoped>
    @import '~common/less/var.less';
    @text: #6D7283;
    @bg: #E0E1EA;
    @highlight-bg: #F4F5F9;
    .x-card-tabs {
        &__nav {
            border: 1px solid @bg;
            border-bottom: 1px solid @highlight-bg;
            position: relative;
            bottom: -1px;
            z-index: 1;
        }
        &__append {
            overflow: hidden;
            text-align: right;
            padding: 5px 0;
        }
        &__item {
            float: left;
            padding: 17px 0 16px;
            width: 120px;
            text-align: center;
            font-size: 15px;
            line-height: 1;
            cursor: pointer;
            color: @text;
            background: @bg;
            &--active {
                background: @highlight-bg;
            }
        }
    }
</style>
